<template>
  <v-carousel
    :hide-delimiters="hideDelimiters"
    :show-arrows="showArrows"
    cycle
    :height="height"
    show-arrows-on-hover
    v-if="!(hideIfEmpty && sliders.length == 0)"
  >
    <v-carousel-item
      :src="slider.image_url"
      :contain="contain"

      v-for="slider in sliders"
      :key="slider.id"
    >
      <h1
        style="top: 15%;left:3%;position:absolute"
        v-text="slider.name"
        :style="{ color: slider.color }"
      ></h1>
      <h3
        style="top: 35%;left:4%;position:absolute"
        v-text="slider.text"
        :style="{ color: slider.color }"
      ></h3>
      <v-btn color="primary" :href="slider.url.replace('/#/', api.url.replace('public/', 'store/#/'))"  rounded large style="top: 55%;left:45%;position:absolute;width:200px" v-if="slider.url">{{ 'view_resource' | trans }}</v-btn>
    </v-carousel-item>
  </v-carousel>
</template>
<script>
export default {
  async mounted() {
    await this.api.ready;
    this.sliders = (await this.api.get("sliders")).data;
  },
  data() {
    return {
      sliders: []
    };
  },
  props: {
    hideIfEmpty: {
      type: Boolean,
      default: true
    },
    hideDelimiters: {
      type: Boolean,
      default: true
    },
    showArrows: {
      type: Boolean,
      default: true
    },
    height: {
        type: [Number, String]
    },
    contain: {
        default: true
    }

  }
};
</script>
